import { cn } from "@/lib/utils"
import type { TaskStatus } from "@/types/tasks"

export const TASK_STATUS_BG_CLASS: Record<TaskStatus, string> = {
  todo: "bg-ui-task-todo",
  in_progress: "bg-ui-task-in-progress",
  review: "bg-ui-task-review",
  done: "bg-ui-task-done",
}

export function TaskStatusDot({ status, className }: { status: TaskStatus; className?: string }) {
  return <span aria-hidden className={cn("size-2 shrink-0 rounded-full", TASK_STATUS_BG_CLASS[status], className)} />
}
